import React, { lazy } from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function ProductShowcase() {
  return <section className="pt-12 md:pt-20 pb-6 md:pb-8 px-4 bg-brand-light" data-id="element-246">
      <div className="max-w-5xl mx-auto text-center" data-id="element-247">
        <div className="inline-flex items-center justify-center gap-2 bg-yellow-100 text-yellow-800 font-bold px-4 py-2 rounded-full mb-6" data-id="element-248">
          <span data-id="element-249">🏆</span> El sistema N°1 para docentes de Biología en Argentina
        </div>

        <h2 className="text-4xl md:text-6xl font-black text-brand-dark mb-4" data-id="element-250">
          🧬 BIOLOGÍA EN ACCIÓN
        </h2>
        <h3 className="text-3xl md:text-4xl font-extrabold text-brand-blue mb-8" data-id="element-251">
          MEGAPACK BIOLOGÍA EN ACCIÓN
        </h3>

        <p className="text-xl text-gray-700 max-w-3xl mx-auto mb-6 md:mb-12" data-id="element-252">
          6 Tomos organizados por año. +360 páginas con actividades
          secuenciadas, laboratorios reales y evaluaciones. 3 Bonos estratégicos
          de implementación. Todo alineado al Diseño Curricular.
        </p>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4 mb-6 md:mb-12" data-id="element-253">
          {['1°', '2°', '3°', '4°', '5°', '6°'].map(year => <div key={year} className="w-16 h-16 bg-white rounded-xl shadow-md flex items-center justify-center text-2xl font-black text-brand-blue border-2 border-brand-blue/10" data-id="element-254">
              {year}
            </div>)}
        </div>

        <div className="grid md:grid-cols-2 gap-6 md:gap-12 items-center" data-id="element-255">
          <div className="text-left bg-white p-5 md:p-8 rounded-2xl shadow-xl" data-id="element-256">
            <h4 className="text-2xl font-black text-brand-dark mb-4 md:mb-6 border-b pb-4" data-id="element-257">
              6 TOMOS COMPLETOS
            </h4>
            <ul className="space-y-4" data-id="element-258">
              {['Por año', 'Con actividades secuenciadas', 'Con laboratorios reales', 'Con evaluaciones'].map((item, i) => <li key={i} className="flex items-center gap-3 text-xl font-bold text-gray-800" data-id="element-259">
                  <CheckCircleIcon className="w-8 h-8 text-brand-green flex-shrink-0" data-id="element-260" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div data-id="element-261">
            <a href="#compra" className="block cursor-pointer transform hover:scale-[1.02] transition-transform duration-300" data-id="element-262">
              <img data-id="element-123" src="https://cdn.magicpatterns.com/uploads/r9a6Xy86W3oqs1XmyDrfyC/biologia_box_mobile_768.webp" alt="MegaPack Biología en Acción" className="w-full drop-shadow-2xl rounded-xl" loading="lazy" width={768} height={1024} />
            </a>
          </div>
        </div>
      </div>
    </section>;
}